import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Vet } from './../../auth/_models/vet';
import { VetsService } from './../../auth/_services/vets.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vet-detail',
  templateUrl: './vet-detail.component.html',
  styleUrls: ['./vet-detail.component.css'],
  providers: [VetsService]
})
export class VetDetailComponent implements OnInit {

  vet: Vet;

  constructor(
    private _service: VetsService,
    private _route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this._route.params.subscribe(params => {
      const uuid = params['id'];
      this._service
        .getVet(uuid)
        .valueChanges()
        .subscribe(v => {

          if (v.birthday) {
            if (typeof v.birthday.toDate === 'function') {
              v.birthday = v.birthday.toDate();
            }
          }

          this.vet = v;
        });
    });
  }

}
